import { defineChain } from "viem";
import { arbitrum, base, bsc, mainnet as ethereum } from "viem/chains";

/**
 * Las cadenas donde vive Keellabs. Arbitrum y BNB Chain vienen de viem; Robinhood y HyperEVM no
 * estan en su catalogo y se definen aqui.
 *
 * `rpcLogs` no cabe en el tipo `Chain` de viem, asi que vive en `networks.ts`: son RPC distintos
 * y por un motivo medido, no por gusto. El de lectura rapida de Arbitrum (publicnode) rechaza
 * `eth_getLogs` desde el bloque 0 y el historial salia vacio; el oficial de HyperEVM corta en 1000
 * bloques y pasa lo mismo. Solo las consultas de eventos van por el RPC alternativo.
 */

/**
 * Multicall3, en su direccion canonica. Esta desplegado en las tres redes (comprobado el
 * 2026-08-12: 3.808 bytes de codigo y `getBlockNumber()` responde en las tres).
 *
 * HAY QUE DECLARARLO O NADA FUNCIONA. Sin esto, `defineChain` no lo trae y cualquier
 * `client.multicall()` revienta con «Chain "X" does not support contract "multicall3"» — que es
 * justo lo que se vio en produccion el 12-ago: la lista de vaults no cargaba en Robinhood.
 * Arbitrum no daba el fallo porque su definicion viene de viem y ya lo trae.
 */
const MULTICALL3 = {
  multicall3: { address: "0xcA11bde05977b3631167028862bE2a173976CA11" },
} as const;

export const robinhood = defineChain({
  id: 4663,
  name: "Robinhood Chain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: ["https://rpc.mainnet.chain.robinhood.com"] } },
  blockExplorers: {
    default: { name: "Blockscout", url: "https://robinhoodchain.blockscout.com" },
  },
  contracts: MULTICALL3,
});

export const hyperevm = defineChain({
  id: 999,
  name: "HyperEVM",
  nativeCurrency: { name: "HYPE", symbol: "HYPE", decimals: 18 },
  rpcUrls: { default: { http: ["https://rpc.hyperliquid.xyz/evm"] } },
  blockExplorers: {
    default: { name: "HyperEVMScan", url: "https://hyperevmscan.io" },
  },
  contracts: MULTICALL3,
});

export { arbitrum, base, bsc, ethereum };

// BNB Chain entra el 2026-08-18, sobre PancakeSwap V3. Su definicion viene de viem y ya trae
// Multicall3, igual que Arbitrum: no hay que declararlo a mano.
// Base (2026-09-04) tambien viene de viem con Multicall3 incluido: no hay que declararlo a mano.
// Ethereum (2026-09-17): la red de siempre, viable OTRA VEZ para un vault que rebalancea. El
// basefee vive por debajo de 0,1 gwei desde que la actividad se fue a las L2 y subió el gas limit
// —medido 0,057 gwei el 2026-09-17—, así que un rebalanceo nuestro (≈900k de gas, medido en cinco
// transacciones reales de Base) sale por ~0,13 $. Viene de viem con su Multicall3.
export const cadenas = [arbitrum, robinhood, hyperevm, bsc, base, ethereum] as const;
export type IdCadena = (typeof cadenas)[number]["id"];
